// extracted by mini-css-extract-plugin
module.exports = {"scrollbar_hidden":"style_scrollbar_hidden__L7i1d","scroll_container":"style_scroll_container__SvYO7"};